// extracted by mini-css-extract-plugin
module.exports = {"container":"header_container__263cy","mccLogo":"header_mccLogo__3E-nC","tel":"header_tel__3pCln","anchor":"header_anchor__2ZZ5r","icon":"header_icon__2jeBO"};